import { ReactNode, useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import slugify from 'slugify';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import { useTracking } from 'hooks';

import Styles from './EmptyState.styles';

export const EmptyState = ({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}) => {
  const { sendDataToGTM } = useTracking();
  const location = useLocation();
  const pathName = location.pathname.substring(1);
  useEffect(() => {
    if (sendDataToGTM && title) {
      sendDataToGTM({
        event: 'analytics-event',
        event_parameters: {
          event_name: `interaction_${pathName}`,
          cd_interaction_detail: `view:${pathName}`,
          cd_error_message: slugify(title, { lower: true }),
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Styles.Wrapper direction='column' align='center'>
      {children}
      <ResponsiveFloraTypography color='$nonInteractivePredominant'>
        {title}
      </ResponsiveFloraTypography>
      <Styles.Subtitle color='$nonInteractiveAuxiliar' fontSize='bodySmallStandard'>
        {subtitle}
      </Styles.Subtitle>
    </Styles.Wrapper>
  );
};
